import { useEffect, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../redux/AppStore";
import { updateShipmentAddress1 } from "../../redux/slice/UpdateTrackingAddressSlice";

export default function ShipmentAddress1Component() {
    const dispatch = useAppDispatch();
    const shipmentAddress1: string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_address1);   

    return (
        <div className="UpdateVerifyInput first_width">
            <label>Address Line 1</label>
            <input type="text" className="form-control" placeholder="Address Line 1" value={shipmentAddress1} onChange={t => {
                dispatch(
                    updateShipmentAddress1(t.target.value)
                )
            }
            } />
        </div>
    );
}